@let selectedLabel = textToShow(selectedOption()); @let selectedValue = getValue(selectedOption());

<button
  class="preset-body-3 md:preset-body-2 bg-primary-300 flex w-full items-center gap-2 rounded-full py-1 pr-1 pl-3 text-white"
  cdkOverlayOrigin
  #trigger="cdkOverlayOrigin"
  (click)="isOpen.set(!isOpen())">
  <div class="flex items-center gap-2">
    <span class="font-bold capitalize">{{ selectedLabel }}</span>
  </div>
  <span
    [class.rotate-180]="isOpen() && rotateIcon()"
    class="text-gray-soft ml-auto transition-transform">
    <ng-content select="icon"></ng-content>
  </span>
</button>

<ng-template
  cdkConnectedOverlay
  [cdkConnectedOverlayOrigin]="trigger"
  [cdkConnectedOverlayOpen]="isOpen()"
  [cdkConnectedOverlayHasBackdrop]="true"
  [cdkConnectedOverlayBackdropClass]="'bg-black/30'"
  cdkConnectedOverlayWidth="auto"
  (backdropClick)="isOpen.set(false)"
  (detach)="isOpen.set(false)">
  <ul class="shadow-card divide-primary-300 divide-y-2 rounded-2xl bg-white">
    @for (option of options(); track option) {
    <li
      class="flex cursor-pointer items-center gap-2 px-4 py-3"
      (click)="select(option)"
      [clicks]="'selector-' + textToShow(option)">
      <input
        class="hidden"
        type="radio"
        name="selector-options"
        [checked]="getValue(option) === selectedValue" />

      <span class="bg-primary-300 shadow-black-inset size-5 rounded-full p-0.75">
        @if (getValue(option) === selectedValue) {
        <span class="bg-primary-900 block size-full rounded-full"></span>
        }
      </span>

      <span
        class="preset-body-3 md:preset-body-2 text-primary-900 capitalize"
        [class.font-bold]="getValue(option) === selectedValue"
        [class.text-blue-400]="getValue(option) === selectedValue">
        {{ textToShow(option) }}
      </span>
    </li>
    }
  </ul>
</ng-template>
